import Button from "@src/components/elements/input/Button";
import Checkbox from "@src/components/elements/input/Checkbox";
import Input from "@src/components/elements/input/Input";
import BackButton from "@src/components/nav/BackButton";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import TextareaAutosize from "react-textarea-autosize";
import tw from "twin.macro";

const CreateAccount = () => {
  const [privacyCheck, setPrivacyCheck] = useState(false);
  const [newsletterCheck, setNewsletterCheck] = useState(false);
  const [email, setEmail] = useState("");
  const [surname, setSurname] = useState("");
  const [lastname, setLastname] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const { t } = useTranslation();

  return (
    <>
      <div className="pl-4 pt-4">
        <BackButton stepback desktopVisible />
      </div>
      <form>
        <div className="grid grid-flow-row gap-6 text-gray-700">
          <section className="relative">
            <img
              src="/images/info/jobangebote_job_angebote_2_tradefoox.jpg"
              className="h-[300px] w-full object-cover"
            />
            <div className="absolute left-6 top-1/2 flex -translate-y-1/2 flex-col font-semibold italic">
              <div className="ml-4 w-fit bg-darkblue bg-opacity-80 px-1 text-white">
                {t("pages.createAccount.text1")}
              </div>
            </div>
          </section>

          <article className="grid grid-flow-row gap-3 px-4 text-sm">
            <h1 className="text-base font-semibold">{t("pages.createAccount.text2")}</h1>
            <div>{t("pages.createAccount.text3")}</div>
            <div>{t("pages.createAccount.text4")}</div>
            <div>{t("pages.createAccount.text5")}</div>
            <div>{t("pages.createAccount.text6")}</div>
            <div>{t("pages.createAccount.text7")}</div>
            <div>{t("pages.createAccount.text8")}</div>
            <h1 className="text-base font-semibold">{t("pages.createAccount.text9")}</h1>
            <div>{t("pages.createAccount.text10")}</div>
            <div>{t("pages.createAccount.text11")}</div>
            <div>{t("pages.createAccount.text12")}</div>
            <div>{t("pages.createAccount.text13")}</div>
            <div>{t("pages.createAccount.text14")}</div>
            <div>{t("pages.createAccount.text15")}</div>
          </article>
          <div className="grid grid-flow-row gap-6 px-4 pb-4">
            <Input
              label={t("pages.createAccount.label1")}
              type="text"
              name="company"
              placeholder={t("pages.createAccount.placeholder1")}
              value={company}
              onChange={e => {
                setCompany(e);
              }}
              required
            />
            <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
              <Input
                label={t("main.profileViewTabs.editProfile.form.firstName")}
                type="text"
                name="surname"
                placeholder="Max"
                value={surname}
                onChange={e => {
                  setSurname(e);
                }}
                required
              />
              <Input
                label={t("main.profileViewTabs.editProfile.form.lastName")}
                type="text"
                name="name"
                placeholder="Mustermann"
                value={lastname}
                onChange={e => {
                  setLastname(e);
                }}
                required
              />
              <Input
                label={t("main.profileViewTabs.editProfile.form.email")}
                type="text"
                name="email"
                placeholder="E-Mail"
                value={email}
                onChange={e => {
                  setEmail(e);
                }}
                required
              />
              <Input
                label={t("main.profileViewTabs.editProfile.form.phone")}
                type="text"
                name="phone"
                placeholder="+49 1234 123456"
                value={phone}
                onChange={e => {
                  setPhone(e);
                }}
                required
              />
            </div>
            <div>
              {t("pages.createAccount.text16")}
              <TextareaAutosize
                minRows={3}
                value={message}
                onChange={e => {
                  setMessage(e.target.value);
                }}
                css={[tw`block w-full rounded-xl py-3 px-4 bg-gray-200 border-0`]}
                required
              />
            </div>
            <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
              <Checkbox
                name="agb"
                required
                checked={privacyCheck}
                onChange={e => setPrivacyCheck(e)}
              >
                {t("pages.createAccount.text17")}{" "}
                <NavLink to="/datenschutz" target="_blank">
                  {t("pages.createAccount.text18")}
                </NavLink>{" "}
                {t("pages.createAccount.text19")}
              </Checkbox>
              <Checkbox
                name="newsletter"
                checked={newsletterCheck}
                onChange={e => setNewsletterCheck(e)}
              >
                {t("components.shared.acceptNewsletter")}
              </Checkbox>
              <Button submit>{t("buttons.send")}</Button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default CreateAccount;
